import $ from 'jquery';

class ExpandTerms {
    constructor () {
        this.$                  = $;
        this.$term              = $('.js-term');
        this.$expandTermsButton = $('.js-terms-expand-button');

        this.$expandTermsButton.on('click', $.proxy(this.termsExpandClick, this));
    }

    /**
     * On click, add the open class and change aria expanded attribute.
     */
    termsExpandClick (e) {
        const $elem  = this.$(e.target);
        const parent = $elem.closest('.js-terms-list');

        parent.addClass('is-open');
        parent.find(this.$term).attr('aria-expanded', 'true');
    }
}

export default ExpandTerms;
